import Axios from "./axios";

const resource = "shop-assignment-sliders";

export default {
  get() {
		return Axios.get(`${resource}`);
	}
}